// https://egghead.io/lessons/javascript-redux-persisting-the-state-to-the-local-storage

import { sendError } from '../helpers/errorReport';

type NameEnum = 'user' | 'general';

export const loadLSItem = (name: NameEnum): unknown => {
  try {
    const serializedItem = localStorage.getItem(name);
    if (serializedItem === null) return undefined;
    return JSON.parse(serializedItem);
  } catch (error: any) {
    sendError(error, {
      type: 'LOCAL_STORAGE_GETITEM',
    });
    return undefined;
  }
};

export const saveLSItem = (item: unknown, name: NameEnum): void => {
  try {
    if (!item) {
      localStorage.removeItem(name);
    } else {
      localStorage.setItem(name, JSON.stringify(item));
    }
  } catch (error: any) {
    sendError(error, {
      type: 'LOCAL_STORAGE_SETITEM',
    });
  }
};

export const loadGeneral = () => loadLSItem('general');
export const loadUser = () => loadLSItem('user');

export const saveGeneral = (data: unknown) => saveLSItem(data, 'general');
export const saveUser = (data: unknown) => saveLSItem(data, 'user');
